import { observer } from "mobx-react-lite";
import React from "react";
import { FormControl } from "react-bootstrap";
import { useFormContext } from "./Form";
import { emptyStringIfNull, withFormWrapper, } from "./withFormWrapper";
import { StaticInputValue } from "./StaticInput";
export const RawInput = observer(({ name, type, disabled, autoFocus, onChange, min, max, step, maxLength, label, staticFormatter, autoComplete = "off", dataId, dataLabel, dataTestId, ariaLabelledby, placeholder, }) => {
    const { values, formDisabled, isStatic } = useFormContext();
    const handleChange = React.useCallback((e) => {
        if (onChange) {
            onChange(e.target.value, values.get(name));
        }
        values.set(name, e.target.value);
    }, [onChange, values, name]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(FormControl, { name: name, type: type, value: emptyStringIfNull(values.get(name)), disabled: disabled || formDisabled, autoFocus: autoFocus, onChange: handleChange, min: min, max: max, step: step, maxLength: maxLength, autoComplete: autoComplete, "aria-labelledby": ariaLabelledby, placeholder: placeholder }));
});
export const Input = withFormWrapper({ WrappedComponent: RawInput });
